<template>
  <table class="w-full">
    <thead class="font-medium">
      <tr>
        <th
          v-for="(heading, index) in tableHeadings"
          :key="heading"
          scope="col"
          :class="index !== 0 && `text-center px-1`"
          class="pb-8 md:pb-16 text-s md:text-m"
        >
          {{ heading }}
        </th>
      </tr>
    </thead>
    <tbody>
      <slot></slot>
    </tbody>
  </table>
</template>

<script lang="ts">
export default {
  name: 'FeatureTable',
  props: {
    tableHeadings: {
      type: Array,
      required: true,
    },
  },
};
</script>
